<div class="cardModal">
    <div class="cardTitle">
        <h3>{{ (data.id ? 'users.accessGroups.createEdit.editHeader' : 'users.accessGroups.createEdit.createHeader') | translate }}</h3>
    </div>

    <div class="cardContent">
        <!--        <app-loader [type]="'overlayAndSpinner'" [matchAny]="true"/>-->
        <form [formGroup]="createAccessGroupForm">
            @if (userIsAdmin) {
                <div class="inputGroup">
                    <span class="label">{{ 'users.userGroups.createEdit.companyName' | translate }}</span>
                    <div class="inputWrapper">
                        <app-form-error [parentForm]="createAccessGroupForm" [controlPath]="'companyName'" />
                        <app-typeahead-select
                            formControlName="companyName"
                            class="formControl"
                            [id]="'companyName'"
                            [optionsList]="suppliers"
                            [idKey]="'id'"
                            [labelKey]="'companyName'"
                        />
                    </div>
                </div>
            }

            @if (accessGroupFilters && accessGroupFilters.listings.length) {
                <div class="inputGroup">
                    <label for="accessGroupName">{{ 'users.accessGroups.createEdit.accessGroupName' | translate }}</label>
                    <div class="inputWrapper">
                        <app-form-error [parentForm]="createAccessGroupForm" [controlPath]="'accessGroupName'" />
                        <input type="text" formControlName="accessGroupName" id="accessGroupName" trimInput />
                    </div>
                </div>
                <div class="multiSelectFilters borderTop">
                    <h3>{{ 'users.accessGroups.createEdit.brandsAndCountriesLabel' | translate }}</h3>
                    <div class="inputGroup labelTop">
                        <label for="brands">{{ 'users.accessGroups.createEdit.brandsLabel' | translate }}</label>
                        <div class="inputWrapper">
                            <app-multi-select-input
                                formControlName="brands"
                                id="brands"
                                [optionsList]="accessGroupFilters.brands"
                                [idKey]="'id'"
                                [labelKey]="'displayText'"
                            />
                        </div>
                    </div>
                    <div class="inputGroup labelTop">
                        <label for="countries">{{ 'users.accessGroups.createEdit.countriesLabel' | translate }}</label>
                        <div class="inputWrapper">
                            <app-multi-select-input
                                formControlName="countries"
                                id="countries"
                                [optionsList]="accessGroupFilters.countries"
                                [idKey]="'id'"
                                [labelKey]="'displayText'"
                            />
                        </div>
                    </div>
                    <div class="multiSelectFilters borderTop">
                        <button class="button secondary borderTop" (click)="showListingsFilter = !showListingsFilter">
                            {{ 'users.accessGroups.createEdit.addExtraListings' | translate }}
                        </button>
                        @if (showListingsFilter) {
                            <div class="inputGroup labelTop">
                                <label for="listings">{{ 'users.accessGroups.createEdit.listingsLabel' | translate }}</label>
                                <div class="inputWrapper">
                                    <app-multi-select-input
                                        formControlName="listings"
                                        id="listings"
                                        [dynamicOptions]="dynamicOptions"
                                        [idKey]="'id'"
                                        [labelKey]="'name'"
                                    />
                                </div>
                            </div>
                        }
                    </div>
                </div>
                <app-form-error [parentForm]="createAccessGroupForm" [showError]="showFormError" />
            } @else {
                @if (selectedSupplierId) {
                    <div class="infoNotification">
                        <i class="fa-solid fa-circle-info"></i>
                        <span class="label">
                            {{ 'users.accessGroups.createEdit.noListingsYetHint' | translate }}
                        </span>
                    </div>
                }
            }
        </form>
    </div>
    <div class="cardFooter">
        <footer class="buttonArea stickyBottom centeredButtons">
            @if (accessGroupFilters && accessGroupFilters.listings.length) {
                <button type="submit" class="button primary" (click)="createAccessGroup()">
                    {{ 'users.accessGroups.createEdit.updateAccessGroup' | translate }}
                </button>
            }
            <button type="button" class="button" (click)="closeModal(false)">
                {{ 'users.accessGroups.createEdit.updateAccessGroupCancel' | translate }}
            </button>
        </footer>
    </div>
</div>
